"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _reactI18next = require("react-i18next");
var _actions = require("@otpusk/apisearch-toolbox/dist/geo/actions");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _services = require("@otpusk/apisearch-toolbox/dist/services");
var _actions2 = require("@otpusk/apisearch-toolbox/dist/search/actions");
var _Select = _interopRequireDefault(require("../../../ui/Select"));
var _actions3 = require("../GeoTreeControl/store/actions");
var _actions4 = require("../../store/actions");
var _selectors2 = require("../../store/selectors");
var _actions5 = require("./store/actions");
var _helpers = require("./helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CountryControl = function CountryControl() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var countries = (0, _reactRedux.useSelector)(_selectors.getCountries);
  var lastLoadingHotelsByKey = (0, _reactRedux.useSelector)(_selectors2.getLastLoadingHotelsByKey);
  var items = (0, _react.useMemo)(function () {
    return (0, _helpers.sortCountriesByList)(countries);
  }, [countries]);
  var label = t('FROM_CONTROL_LABEL');
  return /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: _fn.QUERY_PARAMS.COUNTRY,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_Select.default, {
        hasError: !field.value,
        items: items,
        label: label,
        value: (0, _helpers.getItemValue)(items, field.value),
        onChange: function onChange(_ref2) {
          var countryID = _ref2.countryID;
          var BASE_QUERY = (0, _fn.createQuery)().toJS();
          var _form$values = form.values,
            prevCountryID = _form$values[_fn.QUERY_PARAMS.COUNTRY],
            selectedDepartureIDs = _form$values[_fn.QUERY_PARAMS.DEPARTURES],
            selectedTransports = _form$values[_fn.QUERY_PARAMS.TRANSPORTS];
          form.setFieldValue(field.name, countryID);
          dispatch((0, _actions5.getDeparture)(countryID, selectedDepartureIDs, selectedTransports, function (departures) {
            form.setFieldValue(_fn.QUERY_PARAMS.DEPARTURES, R.map(R.prop('departureID'), departures));
            form.setFieldValue(_fn.QUERY_PARAMS.TRANSPORTS, R.map(function (_ref3) {
              var transport = _ref3.transport;
              return R.assoc(transport, true, R.mapObjIndexed(R.F, BASE_QUERY[_fn.QUERY_PARAMS.TRANSPORTS][0]));
            }, departures));
            var _iterator = _createForOfIteratorHelper(departures),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var departure = _step.value;
                dispatch(_actions.geoActions.getOperators(countryID, departure.departureID, '2.6'));
                dispatch(_actions2.searchActions.getAvailableDates(countryID, departure.departureID));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }));
          R.forEach(function (_ref4) {
            var paramName = _ref4.paramName,
              paramValue = _ref4.paramValue;
            return form.setFieldValue(paramName, paramValue);
          }, (0, _helpers.createPreset)(countryID));
          dispatch((0, _actions3.getData)(countryID, true));
          form.setFieldValue(_fn.QUERY_PARAMS.PROVINCES, BASE_QUERY[_fn.QUERY_PARAMS.PROVINCES]);
          form.setFieldValue(_fn.QUERY_PARAMS.DISTRICTS, BASE_QUERY[_fn.QUERY_PARAMS.DISTRICTS]);
          form.setFieldValue(_fn.QUERY_PARAMS.CITIES, BASE_QUERY[_fn.QUERY_PARAMS.CITIES]);
          dispatch(_actions.geoActions.getHotels(countryID, false));
          dispatch(_actions.geoActions.removeHotels(prevCountryID));
          if (lastLoadingHotelsByKey) {
            dispatch(_actions.geoActions.removeHotels(lastLoadingHotelsByKey));
            dispatch((0, _actions4.setLastLoadingHotelsByKey)(null));
          }
          form.setFieldValue(_fn.QUERY_PARAMS.HOTELS, BASE_QUERY[_fn.QUERY_PARAMS.HOTELS]);
          form.setFieldValue(_fn.QUERY_PARAMS.OPERATORS, BASE_QUERY[_fn.QUERY_PARAMS.OPERATORS]);
          dispatch(_services.servicesActions.getServices(countryID));
          form.setFieldValue(_fn.QUERY_PARAMS.SERVICES, BASE_QUERY[_fn.QUERY_PARAMS.SERVICES]);
        }
      });
    }
  });
};
var _default = exports.default = (0, _react.memo)(CountryControl);